import type DropdownItem from './dropdown-item';

/** The AutocompleteEvent represents a DropdownItem selection change, caused by the user or replacing the data source. */
export default class AutoCompleteEvent extends Event {
	/**
	 * The static SELECTED_ITEM_CHANGED type is dispatched when the user selects a DropdownItem of the data property is reset.
	 *
	 * Example: addEventListener(AutocompleteEvent.SELECTED_ITEM_CHANGED, (event: AutocompleteEvent<Value>) => {});
	 */
	public static SELECTED_ITEM_CHANGED = 'AutoCompleteEvent.selectedItemChanged';
	/** The selectedItem property is the DropdownItem that is currently selected. */
	public selectedItem: DropdownItem | null;

	public constructor(item: DropdownItem | null = null) {
		super(AutoCompleteEvent.SELECTED_ITEM_CHANGED, { bubbles: true });
		this.selectedItem = item;
	}
}
